import React from 'react';
import {
  renderCheckboxes,
  renderDropdown,
  renderInputField,
} from '../../../common/inputField';
import { useDispatch, useSelector } from 'react-redux';
import { setPatientData } from '../../../actions';
import CustomSelectField from '../../../common/CustomSelectField';

const SexualHistory = () => {
  const dispatch = useDispatch();
  const patientData = useSelector((state) => state.clinicalReducer);

  const handleInputChange = (e, index) => {
    const { name, checked } = e.target;
    const updatedCheckboxes =
      patientData.patientHistory.sexualHistory.complaints.map((item, idx) =>
        idx === index ? { ...item, checked } : item,
      );

    if (name === 'otherValue') {
      dispatch(
        setPatientData(
          'patientHistory.sexualHistory.complaintsOther',
          e.target.value,
        ),
      );
    } else {
      dispatch(
        setPatientData(`patientHistory.sexualHistory.complaints`, updatedCheckboxes),
      );
    }
  };

  return (
    <React.Fragment>
      <p className="lead">SEXUAL HISTORY</p>
      <div className="card_name_container">

        {renderCheckboxes(
          patientData.patientHistory.sexualHistory.complaints,
          handleInputChange,
          'Complaints',
          'complaints',
          patientData.patientHistory.sexualHistory.complaintsOther,
          true
        )}

      </div>
    </React.Fragment>
  );
};

export default SexualHistory;
